<template>
  <v-dialog max-width="1100px" persistent v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark>
        <v-toolbar-title class="headline">New Customer</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon :disabled="adding_customer" @click="$emit('setDialog', false)">close</v-icon>
      </v-toolbar>
      <v-card-text style="height: auto;">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap>
            <v-flex sm12 md6 class="pr-2">
              <h1 style="font-size:22px;">General Information</h1>
              <v-layout row>
                <v-flex xs6 class="mr-2">
                  <v-text-field
                    v-model="fname"
                    label="First name"
                    :rules="[nameValid.max,nameValid.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 class="ml-2">
                  <v-text-field
                    v-model="lname"
                    label="Last name"
                    :rules="[nameValid.max,nameValid.required]"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-text-field
                v-model="email"
                label="Email"
                :rules="[emailValid.email,emailValid.required,emailValid.already]"
              ></v-text-field>
              <v-layout row>
                <v-flex xs2 class="mr-2">
                  <v-select :items="country_tel" v-model="user_country_tel" label="Select"></v-select>
                </v-flex>
                <v-flex xs10 class="ml-2">
                  <v-text-field
                    v-model="tel"
                    mask="## - ### - ####"
                    label="Tel."
                    :rules="[telValid.leng,telValid.already,telValid.required]"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <div class="line-newpass"></div>
              <v-text-field
                v-model="password1"
                :append-icon="show1 ? 'visibility_off' : 'visibility'"
                :type="show1 ? 'text' : 'password'"
                name="input-1"
                label="Password"
                hint="At least 6 characters"
                class="input-group--focused"
                @click:append="show1 = !show1"
                :rules="[passwordValid.min,passwordValid.max]"
              ></v-text-field>
              <v-text-field
                v-model="password2"
                :append-icon="show2 ? 'visibility_off' : 'visibility'"
                :type="show2 ? 'text' : 'password'"
                name="input-2"
                label="Confirm Password"
                hint="At least 6 characters"
                class="input-group--focused"
                @click:append="show2 = !show2"
                :rules="[passwordValid.min,passwordValid.max]"
              ></v-text-field>
              <div v-if="passwordMatch == false" class="red--text">Password Not match</div>
            </v-flex>

            <v-flex sm12 md6 class="pl-2">
              <br class="hidden-md-and-up">
              <h1 style="font-size:22px;">Address Information</h1>
              <v-textarea
                name="address"
                label="Address"
                v-model="customer_address"
                value
                hint="Hint text"
                rows="1"
              ></v-textarea>
              <v-layout row>
                <v-flex xs6 class="mr-2">
                  <v-select
                    :rules="[rules.required]"
                    :items="provinceItems"
                    v-on:change="onChangeProvince"
                    v-model="customer_province"
                    item-text="province_name_th"
                    item-value="province_id"
                    label="Province"
                  ></v-select>
                </v-flex>
                <v-flex xs6 class="ml-2">
                  <v-select
                    :rules="[rules.required]"
                    :items="districtItems"
                    v-on:change="onChangeDistrict"
                    v-model="customer_district"
                    item-text="district_name_th"
                    item-value="district_id"
                    label="District"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 class="mr-2">
                  <v-select
                    :rules="[rules.required]"
                    :items="subDistrictItems"
                    v-model="customer_sub_district"
                    item-text="sub_district_name_th"
                    item-value="sub_district_id"
                    label="Sub district"
                  ></v-select>
                </v-flex>
                <v-flex xs6 class="ml-2">
                  <v-select
                    :rules="[rules.required]"
                    :items="postcodeItems"
                    v-model="customer_post_code"
                    item-text="zipcode_code"
                    item-value="zipcode_id"
                    label="Post Code"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-textarea name="note" label="Place Note" value hint="Hint text" rows="1"></v-textarea>
              <v-layout row>
                <v-flex xs6 class="mr-2">
                  <v-text-field
                    :rules="[rules.required,rules.onlyDouble]"
                    v-model="customer_address_lat"
                    label="latitude"
                  ></v-text-field>
                  <v-btn @click="change_location++ ">Update map</v-btn>
                </v-flex>
                <v-flex xs6 class="ml-2">
                  <v-text-field
                    :rules="[rules.required,rules.onlyDouble]"
                    v-model="customer_address_long"
                    label="longitude"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-card height="200px" width="auto" color="grey">
                <GoogleMap
                  :latitude="parseFloat(customer_address_lat)"
                  :longitude="parseFloat(customer_address_long)"
                  :change="change_location"
                  :height="400"
                  :zoom="15"
                  :mapType="'all'"
                  :draggable="true"
                  @draged="getDragLocation($event)"
                ></GoogleMap>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="red"
          :disabled="adding_customer"
          flat
          @click="$emit('setDialog', false)"
        >Cancel</v-btn>
        <v-btn
          color="green"
          :disabled="adding_customer"
          :loading="adding_customer"
          flat
          @click="add()"
        >Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["dialog"],
  data() {
    return {
      adding_customer: false,
      change_location: 0,
      passwordMatch: true,
      user_country_tel: "+66",
      tel: "",
      country_tel: ["+66"],
      password1: "",
      password2: "",
      show1: false,
      show2: false,
      username: "",
      email: "",
      fname: "",
      lname: "",
      valid: true,
      rules: {
        onlyDouble: value => {
          const pattern = /^-?([0-9]?[0-9]?[0-9]?[0-9]|[0-9]0)\.{1}\d{1,100}$/;
          return pattern.test(value) || "Invalid";
        },
        required: value => !!value || "Required."
      },
      telValid: {
        required: value => !!value || "Required.",
        leng: v => v.length == 9 || "9 characters",
        already: a => !this.telAlready(a) || "Already in use"
      },
      nameValid: {
        already: a => !this.nameAlready(a) || "Already in use",
        required: value => !!value || "Required.",
        max: v => v.length <= 55 || "Min 55 characters"
      },
      emailValid: {
        already: a => !this.emailAlready(a) || "Already in use",
        required: value => !!value || "Required.",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },
      roleValid: {
        required: value => !!value || "Required."
      },
      passwordValid: {
        min: v => v.length >= 6 || "At least 6 characters",
        max: v => v.length <= 24 || "No more than 24 characters"
      },
      customer_address_lat: 0,
      customer_address_long: 0,
      customer_address: "",
      customer_province: "",
      customer_district: "",
      customer_sub_district: "",
      customer_post_code: "",
      customer_place_note: ""
    };
  },
  watch: {
    password1() {
      if (this.password1.length > 5 && this.password1.length < 25) {
        if (this.password1 != this.password2) {
          this.passwordMatch = false;
        } else {
          this.passwordMatch = true;
        }
      } else {
        this.passwordMatch = true;
      }
    },
    password2() {
      if (this.password2.length > 5 && this.password2.length < 25) {
        if (this.password1 != this.password2) {
          this.passwordMatch = false;
        } else {
          this.passwordMatch = true;
        }
      } else {
        this.passwordMatch = true;
      }
    }
  },
  computed: {
    ...mapState({
      customerData: state => state.fetchCustomerBack.customerData,
      provinceItems: state => state.fetchCustomerBack.provinceAdd,
      districtItems: state => state.fetchCustomerBack.districtAdd,
      subDistrictItems: state => state.fetchCustomerBack.subDistrictAdd,
      postcodeItems: state => state.fetchCustomerBack.zipcodeAdd
    })
  },
  methods: {
    getDragLocation(val) {
      this.customer_address_lat = val.lat;
      this.customer_address_long = val.lng;
    },
    onChangeDistrict() {
      this.customer_sub_district = "";
      this.customer_post_code = "";
      this.$store.dispatch(
        "fetchCustomerBack/getSubDistrictAdd",
        this.customer_district
      );
      this.$store.dispatch(
        "fetchCustomerBack/getZipCodeAdd",
        this.customer_district
      );
    },
    onChangeProvince() {
      this.customer_sub_district = "";
      this.customer_district = "";
      this.customer_post_code = "";
      this.$store.dispatch(
        "fetchCustomerBack/getDistrictAdd",
        this.customer_province
      );
    },
    telAlready(a) {
      let check = 0;
      for (let key in this.customerData) {
        if (a == this.customerData[key].user_tel) {
          check = 1;
        }
      }
      if (check == 0) {
        return false;
      } else {
        return true;
      }
    },
    nameAlready(a) {
      let check = 0;
      for (let key in this.customerData) {
        if (a == this.customerData[key].user_username) {
          check = 1;
        }
      }
      if (check == 0) {
        return false;
      } else {
        return true;
      }
    },
    emailAlready(a) {
      let index = this.customerData.indexOf(this.selectedItem);
      let check = 0;
      for (let key in this.customerData) {
        if (key != index) {
          if (a == this.customerData[key].user_email) {
            check = 1;
          }
        }
      }
      if (check == 0) {
        return false;
      } else if (check == 1) {
        return true;
      }
    },
    async add() {
      if (this.$refs.form.validate()) {
        this.adding_customer = true;
        if (this.password1.length > 5 && this.password1.length < 25) {
          if (this.passwordMatch == true) {
            let userInfo = {
              user_country_tel: "+66",
              user_tel: this.tel,
              user_type: 1,
              user_email: this.email,
              user_password: this.password2,
              user_first_name: this.fname,
              user_last_name: this.lname,
              user_role: 6
            };

            let checkSuccess = await this.$store.dispatch(
              "fetchCustomerBack/addCustomer",
              userInfo
            );
            if (checkSuccess != "error") {
              let address_data = {
                user_address_default: 1,
                user_address_text: this.customer_address,
                user_address_lat: parseFloat(this.customer_address_lat),
                user_address_long: parseFloat(this.customer_address_long),
                user_address_sub_district: this.customer_sub_district,
                user_address_district: this.customer_district,
                user_address_province: this.customer_province,
                user_address_zipcode: this.customer_post_code,
                user_address_user: checkSuccess,
                user_address_note: this.customer_place_note
              };
              this.$store.dispatch(
                "fetchCustomerBack/addCustomerAddress",
                address_data
              );
            } else {
              alert("ไม่สามารถเพิ่มลูกค้าได้");
            }
            this.$emit("setDialog", false);
            this.clear();
          }
        }
        this.password1 = "";
        this.password2 = "";
        this.adding_customer = false;
      }
    },
    clear() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped>
.line-newpass {
  overflow: visible;
  padding: 0;
  border: none;
  border-top: 2px solid black;
  color: #333;
  text-align: center;
  margin-top: 25px;
}

.line-newpass:after {
  content: "Set Password";
  display: inline-block;
  position: relative;
  top: -0.8em;
  font-size: 17px;
  padding: 0 0.25em;
  background: white;
}
</style>

